import AxiosClientWeb from '@th/web/src/utils/AxiosClient';
export default AxiosClientWeb;
